import {atom} from "recoil";
import {FormSearchRentalPeriodModel, RentalPeriodEntityResponse} from "../api/types/rentalPeriods";
import {SelectElementModelFE} from "../api/types/generic";

export const rentalPeriodAtom = atom<RentalPeriodEntityResponse | undefined>({
    key: "rentalPeriod",
    default: undefined
});

export const rentalPeriodsAtom = atom<RentalPeriodEntityResponse[]>({
    key: "rentalPeriods",
    default: []
});

export const unitsAtom = atom<SelectElementModelFE[]>({
    key: "units",
    default: []
});

export const defaultRentalPeriodFilters: FormSearchRentalPeriodModel = {
    name: "",
    tpUnit: "",
    showActive: false
};

export const rentalPeriodFiltersAtom = atom<FormSearchRentalPeriodModel>({
    key: "rentalPeriodFilters",
    default: defaultRentalPeriodFilters
});

export const unitsEnumAtom = atom<string[]>({
    key: "unitsEnum",
    default: []
});